import { useLocation } from "@remix-run/react";
import { useCallback, useMemo } from "react";

export const useLocationSearch = () => {
  const location = useLocation();
  const search = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  const linkTo = useCallback(
    (
      query:
        | Record<string, string>
        | ((cur: URLSearchParams) => Record<string, string>)
    ) => {
      const queryObj = typeof query === "function" ? query(search) : query;
      const copySearch = new URLSearchParams(search.toString());
      Object.entries(queryObj).forEach(([key, value]) => {
        if (value) {
          copySearch.set(key, value);
        } else {
          copySearch.delete(key);
        }
      });
      return `${location.pathname}?${copySearch.toString()}`;
    },
    [location, search]
  );
  return { location, search, linkTo };
};
